import { FC } from 'react'

import { ProfileCard, ProfileCardType } from './Card'
import { ProfileAddModal, ProfileAddModalType } from './AddModal'
import { Form, FormType } from './form/Form'
import {
  SubscribeInstagramWebhook,
  SubscribeInstagramWebhookType,
} from './SubscribeInstagramWebhook'
import { PricingTable, PricingTableType } from './PricingTable'
import { ProfileConnectFlow, ProfileConnectFlowType } from './ConnectFlow'
import {
  BillingPortalButton,
  BillingPortalButtonType,
} from './BillingPortalButton'

export const Profile: FC &
  ProfileCardType &
  ProfileAddModalType &
  FormType &
  SubscribeInstagramWebhookType &
  PricingTableType &
  ProfileConnectFlowType &
  BillingPortalButtonType = (): JSX.Element => <></>

Profile.Card = ProfileCard
Profile.AddModal = ProfileAddModal
Profile.Form = Form
Profile.SubscribeInstagramWebhook = SubscribeInstagramWebhook
Profile.PricingTable = PricingTable
Profile.ConnectFlow = ProfileConnectFlow
Profile.BillingPortalButton = BillingPortalButton
